import React from "react";
import clsx from "clsx";

const formatRupiah = (value: number) => {
    if (!value) return '';
    return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        maximumFractionDigits: 0,
    }).format(value).replace('Rp', 'Rp.').trim();
};

export interface CurrencyInputProps {
    name: string;
    className?: string;
    value: number;
    onChange: (e: React.ChangeEvent<HTMLInputElement>, value: string) => void;
    error?: string;
    placeholder?: string;
    disabled?: boolean;
}

// Gunakan forwardRef agar kompatibel dengan react-hook-form Controller
const CurrencyInputRef = React.forwardRef<HTMLInputElement, CurrencyInputProps>(
    ({ name, className, value, onChange, error, placeholder, disabled }, ref) => {
        const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const inputValue = e.target.value.replace(/[^0-9]/g, '');
            onChange(e, inputValue);
        };

        return (
            <>
                <input
                    type="text"
                    id={name}
                    ref={ref} // penting!
                    className={clsx("form-control", error && 'is-invalid', className)}
                    value={formatRupiah(value)}
                    onChange={handleInputChange}
                    placeholder={placeholder || 'Rp. 0'}
                    disabled={disabled}
                />
                {error && <div className="invalid-feedback">{error}</div>}
            </>
        );
    }
);

CurrencyInputRef.displayName = "CurrencyInput";

export default CurrencyInputRef;
